import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import CryptoJS from "crypto-js";
import createPersistedState from 'vuex-persistedstate'

import router from './../router.js'
import account from './modules/userManagement.js'
import rx from './modules/project.js'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

console.log("Debug state is", debug, process.env.NODE_ENV);

const env = process.env.VUE_APP_DEPLOYMENT_ENV;
console.log(process.env);

const baseUrl = process.env.VUE_APP_API_URL;
console.log("API URL is", baseUrl);

export default new Vuex.Store({

  modules: {
    account,
    rx
  },

  plugins: [
    createPersistedState()
  ],

  state: {
    $http: axios.create({
      baseURL: baseUrl,
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    }),
    newMessages: [],
    displayMessages: [],
    debug: debug
  },

  actions : {
    postToServer(context, dataObject) {

      const hmac = CryptoJS.algo.HMAC.create(
        CryptoJS.algo.SHA256,
        context.state.account.user.secret_key
      );

      const payloadJson = JSON.stringify(dataObject);
      console.log("Payload JSON:", payloadJson);

      hmac.update(JSON.stringify(dataObject));
      const authentication = hmac.finalize();

      console.log("AUTH",authentication.toString());

      return context.state.$http({
        method: 'post',
        data: {
          apiKey: context.state.account.user.email,
          payload: dataObject,
          authentication: authentication.toString()
        }
      }).then(response => {
        if (response.data.status === 'failed' && response.data.reason === 'Login Expired'){
          context.dispatch('account/logout')
        } else if (response.data.status === 'failed' && response.data.reason === 'Invalid Message') {
          context.dispatch('account/logout')
        }
        console.log("Post returned", response.data);
        return response.data
      });
    }
  },
});